import { render } from "./RecoverySectionChart.vue?vue&type=template&id=24c46970&scoped=true"
import script from "./RecoverySectionChart.vue?vue&type=script&lang=js"
export * from "./RecoverySectionChart.vue?vue&type=script&lang=js"

import "./RecoverySectionChart.vue?vue&type=style&index=0&id=24c46970&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c46970"]])

export default __exports__